import { Directive, ViewContainerRef } from "@angular/core";

@Directive({
  selector: "[sidebarIndicator]",
})
export class SidebarIndicatorDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
